<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'SAGN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['SMAG']}}
                                                <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MAGN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['MAG']}}
                                                <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AGN' && !hideBrand">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['AGT']}}
                                                <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PKVC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GPS']['PKVC']}}
                                            </template>
                                            <template v-else-if="header == 'ISOC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CI']}}
                                                <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['ACTM']}}
                                                <i @click="setSortTable('AM')" :class="setSortLogo('AM')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['C']}}
                                                <i @click="setSortTable('BC')" :class="setSortLogo('BC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['CYT']['BCBA']}}
                                            </template>
                                            <template v-else-if="header == 'BA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['BA']}}
                                                <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['TRO']}}
                                                <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TDC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['DC']}}
                                                <i @click="setSortTable('TDC')" :class="setSortLogo('TDC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TDA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['DA']}}
                                                <i @click="setSortTable('TDA')" :class="setSortLogo('TDA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TWC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['WC']}}
                                                <i @click="setSortTable('TWC')" :class="setSortLogo('TWC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TWA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['WA']}}
                                                <i @click="setSortTable('TWA')" :class="setSortLogo('TWA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AWR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['AWR']}}
                                                <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                            </template>

                                            <!-- Member W/L , Provider W/L , Company W/L , SM W/L , MA W/L , AG W/L  -->
                                            <template v-else-if="header == 'WL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['WL']}}
                                                <i @click="setSortTable('WL')" :class="setSortLogo('WL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['PWL']}}
                                            </template>
                                            <template v-else-if="header == 'WWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['WWL']}}
                                                <i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'SAWL' && getUserInfo.AT == 0">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['SAWL']}}
                                                <i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['MAWL']}}
                                                <i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AWL' && getUserInfo.AT <= 2">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['AWL']}}
                                                <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                            </template>

                                            <!-- Upline Payment -->
                                            <template v-else-if="header == 'AUP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['AUP']}}
                                                <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:25px;z-index:100;width:175px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["TNPP"]}}</span></span></div>
                                            </template>

                                            <!-- Member W/L , Poker W/L , Poker Com , Company Com, SM Com, MA Com, AG Com ,Poker Payment -->
                                            <template v-else-if="header == 'PMWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['WL']}}
                                                <i @click="setSortTable('PMWL')" class="sortlogo" :class="setSortLogo('PMWL')"></i>
                                            </template>
                                            <template v-else-if="header == 'PW1WL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['PW1WL']}}
                                                <i @click="setSortTable('PW1WL')" class="sortlogo" :class="setSortLogo('PW1WL')"></i>
                                            </template>
                                            <template v-else-if="header == 'PPC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['PPC']}}
                                                <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color: #000; color: #fff; text-align: left; bottom: -5px; left: 25px; z-index: 100; width: 175px; font-size: 11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["PPCD"]}}</span></span></div>
                                            </template>
                                            <template v-else-if="header == 'PCC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['PCC']}}
                                            </template>
                                            <template v-else-if="header == 'PSMC' && getUserInfo.AT == 0">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['PSMC']}}
                                            </template>
                                            <template v-else-if="header == 'PMAC' && getUserInfo.AT <= 1">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['PMAC']}}
                                            </template>
                                            <template v-else-if="header == 'PAC' && getUserInfo.AT <= 2">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['PAC']}}
                                            </template>
                                            <template v-else-if="header == 'LTP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['LTP']}}
                                                <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:25px;z-index:100;width:175px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["TPP"]}}</span></span></div>
                                            </template>

                                            <!--Final Payment -->
                                            <template v-else-if="header == 'AFP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['AFP']}}
                                                <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color: #000; color: #fff; text-align: left; bottom: -5px; left: 25px; z-index: 100; width: 240px; font-size: 11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["NPPPP"]}}</span></span></div>
                                            </template>
                                            <template v-else-if="header == 'TP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['TE']}}
                                                <i @click="setSortTable('TP')" :class="setSortLogo('TP')" class="sortlogo"></i>
                                            </template>
                                            <!-- <template v-else-if="header == 'SPRWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['SPRWL']}}
                                                <i @click="setSortTable('SPRWL')" :class="setSortLogo('SPRWL')" class="sortlogo"></i>
                                            </template> -->
                                            <template v-else-if="header == 'PERE'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['PERE']}}
                                                <i @click="setSortTable('PERE')" :class="setSortLogo('PERE')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['AGNWL']}}
                                                <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'S'">
                                                <i class="fa fa-times" @click="removeColumn(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                                <div class="d-inline-block"><span class="grid-line">{{getLanguage['WLRPT']['S']}}</span><span class="grid-line">{{ shareIndicator }}</span></div>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('TWLBAG', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['TWLBAG']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="!hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :flat="true"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :disable-branch-nodes="false"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  :limit="1"
                                                  :limitText="count => `+${count}`"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :load-options="loadAgentOptions"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  @input="selectAgentOptions"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol' v-if="hide">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :flat="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :options="ddAgentList2"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent2)"
                                                  :disable-branch-nodes="false"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  :limitText="count => `+${count}`"
                                                  v-model="searchAgent2" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            @input="selectMemberOptions"
                                            @deselect="deSelectMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["RU"]}} :</span>
                                <treeselect :key="dd_referralMemberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadReferralMemberOptions"
                                            :options="ddReferralMemberList"
                                            :defaultOptions="ddReferralDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchReferralUserId > 0 && searchReferralUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.RU')"
                                            @input="selectReferralMemberOptions"
                                            @deselect="deSelectReferralMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchReferralUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="convertToBool(searchCurrency)"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency"
                                            @input="updateCC()" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadSearchMemberCurrencyOptions"
                                            :options="ddCurrencyListFilter"
                                            :auto-load-root-options="convertToBool(searchCurrencyFilter)"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrencyFilter" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RSN']}} :</span>
                                <CInput size="sm"
                                        :value="searchRegisterSourceName"
                                        @change="v => searchRegisterSourceName = v"></CInput>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newsearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newsearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class="table-wrapper mb-2" v-if="searchGameProviderId.length >= 1 && (searchGameProviderId.includes('55') || searchGameProviderId.includes('100') || searchGameProviderId.includes('106') || searchGameProviderId.includes('117') || searchGameProviderId.includes('118')|| searchGameProviderId.includes('131')|| searchGameProviderId.includes('132') || searchGameProviderId.includes('105') || searchGameProviderId.includes('124') || searchGameProviderId.includes('125') || searchGameProviderId.includes('115') || searchGameProviderId.includes('127') || searchGameProviderId.includes('128') || searchGameProviderId.includes('159'))">
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('55')">{{this.getLanguage["BETRPT"]["PKVD"]}}</div>
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('100') || searchGameProviderId.includes('106') || searchGameProviderId.includes('117') || searchGameProviderId.includes('118')|| searchGameProviderId.includes('131')|| searchGameProviderId.includes('132')">{{this.getLanguage["BETRPT"]["MGD"]}}</div>
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('105') || searchGameProviderId.includes('124') || searchGameProviderId.includes('125')">{{this.getLanguage["BETRPT"]["P888D"]}}</div>
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('115') || searchGameProviderId.includes('127') || searchGameProviderId.includes('128')">{{this.getLanguage["BETRPT"]["K918D"]}}</div>
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('159')">{{this.getLanguage["BETRPT"]["W9D"]}}</div>
            </div>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']['NWTLL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                    </div>
                </header>
                <div class="my-1" v-if="backURL">
                    <span>
                        <router-link :to="{ path: backURL, query: { back: 1 }}">
                            {{this.getLanguage['SMB'][backURL.replace('/R/','')]}}
                        </router-link>
                        <i class="fas fa-caret-right mx-2"></i>
                    </span>
                    <span><span style="cursor: default; pointer-events: none">{{this.getLanguage['SMB']['NWTLL']}}</span></span>
                </div>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="35">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                            <tr v-if=" arr_reportTotalList.length == 0"><td colspan="100%">{{this.getLanguage['GL']['NR']}}</td></tr>
                            <tr v-for="(data,index) in sortedReportTotalList" class="reportTotal">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        <a href="#" @click="ShowDetails(data.ISOC)">{{getLanguage['WLRPT']['VA']}}</a>
                                    </template>
                                    <template v-else-if="header == 'SAGN'">
                                    </template>
                                    <template v-else-if="header == 'MAGN'">
                                    </template>
                                    <template v-else-if="header == 'AGN' && !hideBrand">
                                    </template>
                                    <template v-else-if="header == 'PKVC'">
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        {{ data.ISOC }}
                                    </template>
                                    <template v-else-if="header == 'AM'">
                                        {{ formatNumber(data.AM, 0) }}
                                    </template>
                                    <template v-else-if="header == 'BC'">
                                        {{ formatNumber(data.BC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                        {{ data.BCBA }}
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        {{ formatNumber(data.BA, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        {{ formatNumber(data.TA, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TDC'">
                                        {{ formatNumber(data.TDC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'TDA'">
                                        <span :class="data.TDA >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.TDA, 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'TWC'">
                                        {{ formatNumber(data.TWC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'TWA'">
                                        <span class="negative-number">{{ formatNumber(data.TWA, 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <span v-if="data.TA > 0" :class="MarginCal(data.WLA,data.TA) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(data.WLA,data.TA), 2, "") }}%</span>
                                        <span class="" v-else>-</span>
                                    </template>
                                    <!-- Member W/L , Provider W/L , Company W/L , SM W/L , MA W/L , AG W/L  -->
                                    <template v-else-if="header == 'WL'">
                                        <span v-if="data.hasW1 == false" :class="data.WLA >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.WLA, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PWL'">
                                        <span v-if="data.hasW1 == false" :class="data.PWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'WWL'">
                                        <span v-if="data.hasW1 == false" :class="data.WWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.WWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'SAWL' && getUserInfo.AT == 0">
                                        <span v-if="data.hasW1 == false" :class="data.SAWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.SAWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <span v-if="data.hasW1 == false" :class="data.MAWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.MAWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'AWL' && getUserInfo.AT <= 2">
                                        <span v-if="data.hasW1 == false" :class="data.AWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.AWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>

                                    <!-- Upline Payment -->
                                    <template v-else-if="header == 'AUP'" :class="data.AUP >= 0? 'positive-number': 'negative-number'">
                                        <span v-if="data.hasW1 == false">{{ formatNumber(data.AUP, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>

                                    <!-- Member W/L , Poker W/L , Poker Com , Company Com, SM Com, MA Com, AG Com ,Poker Payment -->
                                    <template v-else-if="header == 'PMWL'">
                                        <span :class="data.PMWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PMWL, 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'PW1WL'">
                                        <span :class="data.PW1WL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PW1WL, 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'PPC'">
                                        <span v-if="data.W1PC != null && data.W1PC != 0"
                                              :class="data.W1PC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1PC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PCC'">
                                        <span v-if="data.W1CC != null && data.W1CC != 0"
                                              :class="data.W1CC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1CC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PSMC' && getUserInfo.AT == 0">
                                        <span v-if="data.W1SMC != null && data.W1SMC != 0"
                                              :class="data.W1SMC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1SMC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PMAC' && getUserInfo.AT <= 1">
                                        <span v-if="data.W1MAC != null && data.W1MAC != 0"
                                              :class="data.W1MAC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1MAC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PAC' && getUserInfo.AT <= 2">
                                        <span v-if="data.W1AC != null && data.W1AC != 0"
                                              :class="data.W1AC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1AC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'LTP'">
                                        {{ formatNumber(data.LTP, 2, data.ISOC, false) }}
                                    </template>

                                    <!--Final Payment -->
                                    <template v-else-if="header == 'AFP'">
                                        {{ formatNumber(data.AFP, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TP'">
                                        <span v-if="formatNumber(data.TP, data.ISOC, false) == 0">{{ formatNumber(data.TP, 2, data.ISOC, false) }}</span>
                                        <span v-else-if="formatNumber(data.TP, data.ISOC, false) < 0">{{ formatNumber((data.TP * -1), 2, data.ISOC, false) }}</span>
                                        <span v-else>{{ formatNumber((data.TP * -1), 2, data.ISOC, false) }}</span>
                                    </template>
                                    <!-- <template v-else-if="header == 'SPRWL'">
                                        <span :class="data.SPRWL < 0? 'negative-number': 'positive-number'">{{ formatNumber(data.SPRWL, 2, data.ISOC, false) }}</span>
                                    </template> -->
                                    <template v-else-if="header == 'PERE'">
                                        <span :class="(data.TP/data.WLA)* -100 < 0? 'negative-number': 'positive-number'">{{ formatNumber((data.TP/data.WLA) * -100, 2, "") }}%</span>
                                    </template>

                                    <template v-else-if="header == 'TN'">
                                        {{ formatNumber(data.TN, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'S'">
                                    </template>
                                </td>
                            </tr>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)" :style="renderBackgroundColor(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'SAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['SMAG']}}
                                        <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['MAG']}}
                                        <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGN' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PKVC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GPS']['PKVC']}}
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['ACTM']}}
                                        <i @click="setSortTable('AM')" :class="setSortLogo('AM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['C']}}
                                        <i @click="setSortTable('BC')" :class="setSortLogo('BC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CYT']['BCBA']}}
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['TRO']}}
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TDC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['DC']}}
                                        <i @click="setSortTable('TDC')" :class="setSortLogo('TDC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TDA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['DA']}}
                                        <i @click="setSortTable('TDA')" :class="setSortLogo('TDA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TWC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WC']}}
                                        <i @click="setSortTable('TWC')" :class="setSortLogo('TWC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TWA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WA']}}
                                        <i @click="setSortTable('TWA')" :class="setSortLogo('TWA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['AWR']}}
                                        <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                    </template>

                                    <!-- Member W/L , Provider W/L , Company W/L , SM W/L , MA W/L , AG W/L  -->
                                    <template v-else-if="header == 'WL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('WL')" :class="setSortLogo('WL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PWL']}}
                                    </template>
                                    <template v-else-if="header == 'WWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['WWL']}}
                                        <i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SAWL' && getUserInfo.AT == 0">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['SAWL']}}
                                        <i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['MAWL']}}
                                        <i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AWL' && getUserInfo.AT <= 2">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['AWL']}}
                                        <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                    </template>

                                    <!-- Upline Payment -->
                                    <template v-else-if="header == 'AUP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['AUP']}}
                                        <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:25px;z-index:100;width:175px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["TNPP"]}}</span></span></div>
                                    </template>

                                    <!-- Member W/L , Poker W/L , Poker Com , Company Com, SM Com, MA Com, AG Com ,Poker Payment -->
                                    <template v-else-if="header == 'PMWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('PMWL')" class="sortlogo" :class="setSortLogo('PMWL')"></i>
                                    </template>
                                    <template v-else-if="header == 'PW1WL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PW1WL']}}
                                        <i @click="setSortTable('PW1WL')" class="sortlogo" :class="setSortLogo('PW1WL')"></i>
                                    </template>
                                    <template v-else-if="header == 'PPC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PPC']}}
                                        <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:-180px;z-index:100;width:175px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["PPCD"]}}</span></span></div>
                                    </template>
                                    <template v-else-if="header == 'PCC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PCC']}}
                                    </template>
                                    <template v-else-if="header == 'PSMC' && getUserInfo.AT == 0">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PSMC']}}
                                    </template>
                                    <template v-else-if="header == 'PMAC' && getUserInfo.AT <= 1">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PMAC']}}
                                    </template>
                                    <template v-else-if="header == 'PAC' && getUserInfo.AT <= 2">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PAC']}}
                                    </template>
                                    <template v-else-if="header == 'LTP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['LTP']}}
                                        <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:-180px;z-index:100;width:175px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["TPP"]}}</span></span></div>
                                    </template>

                                    <!--Final Payment -->
                                    <template v-else-if="header == 'AFP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['AFP']}}
                                        <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:-245px;z-index:100;width:240px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["NPPPP"]}}</span></span></div>
                                    </template>
                                    <template v-else-if="header == 'TP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['TE']}}
                                        <i @click="setSortTable('TP')" :class="setSortLogo('TP')" class="sortlogo"></i>
                                    </template>
                                    <!-- <template v-else-if="header == 'SPRWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['SPRWL']}}
                                        <i @click="setSortTable('SPRWL')" :class="setSortLogo('SPRWL')" class="sortlogo"></i>
                                    </template> -->
                                    <template v-else-if="header == 'PERE'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PERE']}}
                                        <i @click="setSortTable('PERE')" :class="setSortLogo('PERE')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['AGNWL']}}
                                        <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'S'">
                                        <i class="fa fa-times" @click="removeColumn(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                        <div class="d-inline-block"><span class="grid-line">{{getLanguage['WLRPT']['S']}}</span><span class="grid-line">{{ shareIndicator }}</span></div>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="34">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                            <tr v-if=" arr_reportTotalList.length == 0"><td colspan="100%">{{this.getLanguage['GL']['NR']}}</td></tr>
                            <tr v-for="(data,index) in sortedReportTotalList" class="reportTotal">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        <a href="#" @click="ShowDetails(data.ISOC)">{{getLanguage['WLRPT']['VA']}}</a>
                                    </template>
                                    <template v-else-if="header == 'SAGN'">
                                    </template>
                                    <template v-else-if="header == 'MAGN'">
                                    </template>
                                    <template v-else-if="header == 'AGN' && !hideBrand">
                                    </template>
                                    <template v-else-if="header == 'PKVC'">
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        {{ data.ISOC }}
                                    </template>
                                    <template v-else-if="header == 'AM'">
                                        {{ formatNumber(data.AM, 0) }}
                                    </template>
                                    <template v-else-if="header == 'BC'">
                                        {{ formatNumber(data.BC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                        {{ data.BCBA }}
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        {{ formatNumber(data.BA, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        {{ formatNumber(data.TA, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TDC'">
                                        {{ formatNumber(data.TDC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'TDA'">
                                        <span :class="data.TDA >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.TDA, 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'TWC'">
                                        {{ formatNumber(data.TWC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'TWA'">
                                        <span class="negative-number">{{ formatNumber(data.TWA, 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <span v-if="data.TA > 0" :class="MarginCal(data.WLA,data.TA) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(data.WLA,data.TA), 2, "") }}%</span>
                                        <span class="" v-else>-</span>
                                    </template>
                                    <!-- Member W/L , Provider W/L , Company W/L , SM W/L , MA W/L , AG W/L  -->
                                    <template v-else-if="header == 'WL'">
                                        <span v-if="data.hasW1 == false" :class="data.WLA >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.WLA, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PWL'">
                                        <span v-if="data.hasW1 == false" :class="data.PWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'WWL'">
                                        <span v-if="data.hasW1 == false" :class="data.WWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.WWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'SAWL' && getUserInfo.AT == 0">
                                        <span v-if="data.hasW1 == false" :class="data.SAWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.SAWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <span v-if="data.hasW1 == false" :class="data.MAWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.MAWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'AWL' && getUserInfo.AT <= 2">
                                        <span v-if="data.hasW1 == false" :class="data.AWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.AWL, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>

                                    <!-- Upline Payment -->
                                    <template v-else-if="header == 'AUP'" :class="data.AUP >= 0? 'positive-number': 'negative-number'">
                                        <span v-if="data.hasW1 == false">{{ formatNumber(data.AUP, 2, data.ISOC, false) }}</span>
                                        <span v-else>-</span>
                                    </template>

                                    <!-- Member W/L , Poker W/L , Poker Com , Company Com, SM Com, MA Com, AG Com ,Poker Payment -->
                                    <template v-else-if="header == 'PMWL'">
                                        <span :class="data.PMWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PMWL, 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'PW1WL'">
                                        <span :class="data.PW1WL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PW1WL, 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'PPC'">
                                        <span v-if="data.W1PC != null && data.W1PC != 0"
                                              :class="data.W1PC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1PC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PCC'">
                                        <span v-if="data.W1CC != null && data.W1CC != 0"
                                              :class="data.W1CC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1CC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PSMC' && getUserInfo.AT == 0">
                                        <span v-if="data.W1SMC != null && data.W1SMC != 0"
                                              :class="data.W1SMC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1SMC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PMAC' && getUserInfo.AT <= 1">
                                        <span v-if="data.W1MAC != null && data.W1MAC != 0"
                                              :class="data.W1MAC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1MAC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'PAC' && getUserInfo.AT <= 2">
                                        <span v-if="data.W1AC != null && data.W1AC != 0"
                                              :class="data.W1AC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1AC, 2, data.ISOC, false) }}
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'LTP'">
                                        {{ formatNumber(data.LTP, 2, data.ISOC, false) }}
                                    </template>

                                    <!--Final Payment -->
                                    <template v-else-if="header == 'AFP'">
                                        {{ formatNumber(data.AFP, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TP'">
                                        <span v-if="formatNumber(data.TP, data.ISOC, false) == 0">{{ formatNumber(data.TP, 2, data.ISOC, false) }}</span>
                                        <span v-else-if="formatNumber(data.TP, data.ISOC, false) < 0">{{ formatNumber((data.TP * -1), 2, data.ISOC, false) }}</span>
                                        <span v-else>{{ formatNumber((data.TP * -1), 2, data.ISOC, false) }}</span>
                                    </template>
                                    <!-- <template v-else-if="header == 'SPRWL'">
                                        <span :class="data.SPRWL < 0? 'negative-number': 'positive-number'">{{ formatNumber(data.SPRWL, 2, data.ISOC, false) }}</span>
                                    </template> -->
                                    <template v-else-if="header == 'PERE'">
                                        <span :class="(data.TP/data.WLA)* -100 < 0? 'negative-number': 'positive-number'">{{ formatNumber((data.TP/data.WLA) * -100, 2, "") }}%</span>
                                    </template>

                                    <template v-else-if="header == 'TN'">
                                        {{ formatNumber(data.TN, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'S'">
                                    </template>
                                </td>
                            </tr>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)" :style="renderBackgroundColor(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'SAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['SMAG']}}
                                        <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['MAG']}}
                                        <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGN' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PKVC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GPS']['PKVC']}}
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['ACTM']}}
                                        <i @click="setSortTable('AM')" :class="setSortLogo('AM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['C']}}
                                        <i @click="setSortTable('BC')" :class="setSortLogo('BC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CYT']['BCBA']}}
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['TRO']}}
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TDC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['DC']}}
                                        <i @click="setSortTable('TDC')" :class="setSortLogo('TDC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TDA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['DA']}}
                                        <i @click="setSortTable('TDA')" :class="setSortLogo('TDA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TWC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WC']}}
                                        <i @click="setSortTable('TWC')" :class="setSortLogo('TWC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TWA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WA']}}
                                        <i @click="setSortTable('TWA')" :class="setSortLogo('TWA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['AWR']}}
                                        <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                    </template>

                                    <!-- Member W/L , Provider W/L , Company W/L , SM W/L , MA W/L , AG W/L  -->
                                    <template v-else-if="header == 'WL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('WL')" :class="setSortLogo('WL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PWL']}}
                                    </template>
                                    <template v-else-if="header == 'WWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['WWL']}}
                                        <i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SAWL' && getUserInfo.AT == 0">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['SAWL']}}
                                        <i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['MAWL']}}
                                        <i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AWL' && getUserInfo.AT <= 2">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['AWL']}}
                                        <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                    </template>

                                    <!-- Upline Payment -->
                                    <template v-else-if="header == 'AUP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['AUP']}}
                                        <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:-180px;z-index:100;width:175px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["TNPP"]}}</span></span></div>
                                    </template>

                                    <!-- Member W/L , Poker W/L , Poker Com , Company Com, SM Com, MA Com, AG Com ,Poker Payment -->
                                    <template v-else-if="header == 'PMWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('PMWL')" class="sortlogo" :class="setSortLogo('PMWL')"></i>
                                    </template>
                                    <template v-else-if="header == 'PW1WL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PW1WL']}}
                                        <i @click="setSortTable('PW1WL')" class="sortlogo" :class="setSortLogo('PW1WL')"></i>
                                    </template>
                                    <template v-else-if="header == 'PPC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PPC']}}
                                        <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:-180px;z-index:100;width:175px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["PPCD"]}}</span></span></div>
                                    </template>
                                    <template v-else-if="header == 'PCC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PCC']}}
                                    </template>
                                    <template v-else-if="header == 'PSMC' && getUserInfo.AT == 0">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PSMC']}}
                                    </template>
                                    <template v-else-if="header == 'PMAC' && getUserInfo.AT <= 1">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PMAC']}}
                                    </template>
                                    <template v-else-if="header == 'PAC' && getUserInfo.AT <= 2">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PAC']}}
                                    </template>
                                    <template v-else-if="header == 'LTP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['LTP']}}
                                        <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:-180px;z-index:100;width:175px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["TPP"]}}</span></span></div>
                                    </template>

                                    <!--Final Payment -->
                                    <template v-else-if="header == 'AFP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['AFP']}}
                                        <div class="custom-tooltip ml-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext" style="background-color:#000;color:#fff;text-align:left;bottom:-5px;left:-245px;z-index:100;width:240px;font-size:11px"><span style="white-space:pre-line">{{getLanguage["WLRPT"]["NPPPP"]}}</span></span></div>
                                    </template>
                                    <template v-else-if="header == 'TP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['TE']}}
                                        <i @click="setSortTable('TP')" :class="setSortLogo('TP')" class="sortlogo"></i>
                                    </template>
                                    <!-- <template v-else-if="header == 'SPRWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['SPRWL']}}
                                        <i @click="setSortTable('SPRWL')" :class="setSortLogo('SPRWL')" class="sortlogo"></i>
                                    </template> -->
                                    <template v-else-if="header == 'PERE'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['PERE']}}
                                        <i @click="setSortTable('PERE')" :class="setSortLogo('PERE')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['AGNWL']}}
                                        <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'S'">
                                        <i class="fa fa-times" @click="removeColumn(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                        <div class="d-inline-block"><span class="grid-line">{{getLanguage['WLRPT']['S']}}</span><span class="grid-line">{{  }}</span></div>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_reportList.length == 0 && bool_showDetails">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in sortedReportList" v-if="bool_showDetails && str_showDetails == data.ISOC">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ index+1 }}
                                </template>
                                <template v-else-if="header == 'SAGN'">
                                    {{ data.SAGN }}
                                </template>
                                <template v-else-if="header == 'MAGN'">
                                    {{ data.MAGN }}
                                </template>
                                <template v-else-if="header == 'AGN' && !hideBrand">
                                    <router-link :to="{ path: getLinkUrl(), query:{ gpi: searchGameProviderId, agi: data.AGI, u: sc_username, i: sc_userid, curf: searchCurrencyFilter, df: parseDateToJsonString(sc_daterange.startDate), dt: parseDateToJsonString(sc_daterange.endDate) }}">
                                        {{ data.AGN }}
                                    </router-link>
                                </template>
                                <template v-else-if="header == 'PKVC'">
                                    {{ data.PKVC }}
                                </template>
                                <template v-else-if="header == 'ISOC'">
                                    {{ data.ISOC }}
                                </template>
                                <template v-else-if="header == 'AM'">
                                    {{ formatNumber(data.AM, 0) }}
                                </template>
                                <template v-else-if="header == 'BC'">
                                    {{ formatNumber(data.BC, 0) }}
                                </template>
                                <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                    {{ data.BCBA }}
                                </template>
                                <template v-else-if="header == 'BA'">
                                    {{ formatNumber(data.BA, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TA'">
                                    {{ formatNumber(data.TA, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TDC'">
                                    {{ formatNumber(data.TDC, 0) }}
                                </template>
                                <template v-else-if="header == 'TDA'">
                                    <span :class="data.TDA >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.TDA, 2, data.ISOC, false) }}</span>
                                </template>
                                <template v-else-if="header == 'TWC'">
                                    {{ formatNumber(data.TWC, 0) }}
                                </template>
                                <template v-else-if="header == 'TWA'">
                                    <span class="negative-number">{{ formatNumber(data.TWA, 2, data.ISOC, false) }}</span>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <span v-if="data.TA > 0" :class="MarginCal(data.WLA,data.TA) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(data.WLA,data.TA), 2, "") }}%</span>
                                    <span class="" v-else>-</span>
                                </template>

                                <!-- Member W/L , Provider W/L , Company W/L , SM W/L , MA W/L , AG W/L  -->
                                <template v-else-if="header == 'WL'">
                                    <span v-if="data.hasW1 == false" :class="data.WLA >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.WLA, 2, data.ISOC, false) }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <span v-if="data.hasW1 == false" :class="data.PWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PWL, 2, data.ISOC, false) }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'WWL'">
                                    <span v-if="data.hasW1 == false" :class="data.WWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.WWL, 2, data.ISOC, false) }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'SAWL' && getUserInfo.AT == 0">
                                    <span v-if="data.hasW1 == false" :class="data.SAWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.SAWL, 2, data.ISOC, false) }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                    <span v-if="data.hasW1 == false" :class="data.MAWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.MAWL, 2, data.ISOC, false) }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'AWL' && getUserInfo.AT <= 2">
                                    <span v-if="data.hasW1 == false" :class="data.AWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.AWL, 2, data.ISOC, false) }}</span>
                                    <span v-else>-</span>
                                </template>

                                <!-- Upline Payment -->
                                <template v-else-if="header == 'AUP'">
                                    <span v-if="data.hasW1 == false">{{ formatNumber(data.AUP, 2, data.ISOC, false) }}</span>
                                    <span v-else>-</span>
                                </template>

                                <!-- Member W/L , Poker W/L , Poker Com , Company Com, SM Com, MA Com, AG Com ,Poker Payment -->
                                <template v-else-if="header == 'PMWL'">
                                    <span :class="data.PMWL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PMWL, 2, data.ISOC, false) }}</span>
                                </template>
                                <template v-else-if="header == 'PW1WL'">
                                    <span :class="data.PW1WL >= 0? 'positive-number': 'negative-number'">{{ formatNumber(data.PW1WL, 2, data.ISOC, false) }}</span>
                                </template>
                                <template v-else-if="header == 'PPC'">
                                    <span v-if="data.W1PC != null && data.W1PC != 0"
                                          :class="data.W1PC >= 0? 'positive-number': 'negative-number'">
                                        {{ formatNumber(data.W1PC, 2, data.ISOC, false) }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'PCC'">
                                    <span v-if="data.W1CC != null && data.W1CC != 0"
                                          :class="data.W1CC >= 0? 'positive-number': 'negative-number'">
                                        {{ formatNumber(data.W1CC, 2, data.ISOC, false) }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'PSMC' && getUserInfo.AT == 0">
                                    <span v-if="data.W1SMC != null && data.W1SMC != 0"
                                          :class="data.W1SMC >= 0? 'positive-number': 'negative-number'">
                                        {{ formatNumber(data.W1SMC, 2, data.ISOC, false) }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'PMAC' && getUserInfo.AT <= 1">
                                    <span v-if="data.W1MAC != null && data.W1MAC != 0"
                                          :class="data.W1MAC >= 0? 'positive-number': 'negative-number'">
                                        {{ formatNumber(data.W1MAC, 2, data.ISOC, false) }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'PAC' && getUserInfo.AT <= 2">
                                    <span v-if="data.W1AC != null && data.W1AC != 0"
                                          :class="data.W1AC >= 0? 'positive-number': 'negative-number'">
                                        {{ formatNumber(data.W1AC, 2, data.ISOC, false) }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'LTP'">
                                    {{ formatNumber(data.LTP, 2, data.ISOC, false) }}
                                </template>

                                <!--Final Payment -->
                                <template v-else-if="header == 'AFP'">
                                    {{ formatNumber(data.AFP, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TP'">
                                    <span v-if="formatNumber(data.TP, data.ISOC, false) == 0">{{ formatNumber(data.TP, 2, data.ISOC, false) }}</span>
                                    <span v-else-if="formatNumber(data.TP, data.ISOC, false) < 0">{{ formatNumber((data.TP * -1), 2, data.ISOC, false) }}</span>
                                    <span v-else>{{ formatNumber((data.TP * -1), 2, data.ISOC, false) }}</span>
                                </template>
                                <!-- <template v-else-if="header == 'SPRWL'">
                                        <span :class="data.SPRWL < 0? 'negative-number': 'positive-number'">{{ formatNumber(data.SPRWL, 2, data.ISOC, false) }}</span>
                                    </template> -->
                                <template v-else-if="header == 'PERE'">
                                    <span :class="(data.TP/data.WLA)* -100 < 0? 'negative-number': 'positive-number'">{{ formatNumber((data.TP/data.WLA) * -100, 2, "") }}%</span>
                                </template>
                                <template v-else-if="header == 'TN'">
                                    {{ formatNumber(data.TN, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'S'">
                                    <span v-if="data.GPI == 55 || data.PN == 'POKERV'">0.00/0.00/0.00/0.00/0.00</span>
                                    <span v-else>
                                        {{ formatPT(data) }}
                                    </span>
                                </template>
                            </td>
                        </tr>                
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                str_showDetails: "",
                bool_showDetails: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_firstLogin: false,
                // dropdown value
                ddAgentList: null,
                ddAgentList2: null,
                ddGameProviderList: null,
                ddGameCategoryList: null,
                ddMemberList: null,
                ddDefaultMemberList: null,
                ddReferralMemberList: null,
                ddReferralDefaultMemberList: null,
                ddCurrencyList: null,
                bool_isSort: true,
                str_tableSortBy: "TA",
                defaultDescendingColumns: ['AM'],
                lastSortedColumn: null, 
                searchRegisterSourceName: null,
                // search fields
                searchAgi: '',
                searchAgi2: '',
                searchAgT: 0,
                pre_searchAgi: '',
                pre_searchAgT: 0,
                searchAgent: null,
                searchAgent2: [],
                searchAgent2Main: null,
                searchUserId: null,
                searchUsername: null,
                searchReferralUserId: null,
                searchReferralUsername: null,
                searchGameProviderId: [],
                searchCurrency: null,
                searchCurrencyFilter: null,
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                arr_reportList: [],
                arr_reportTotalList: [],
                reportType: null,
                skipPageUpdate: false,
                dd_memberKey: 0,
                dd_referralMemberKey: 0,
                sc_userid: 0,
                sc_username: null,
                sc_daterange: { startDate: null, endDate: null },
                sc_cur: null,
                sc_curf: null,
                sc_agi: null,
                sc_agent: null,
                shareIndicator: "",
                constAccessType: constAccessType,
                repoerIsCrypto: false,
                hideBrand: false,
                searchGameCategoryIds: null,
                selectedAgent: null,
                ddCurrencyListFilter: null,
                //getAGNWL: null,

                defaultReportHeaders: ['NO', 'SAGN', 'MAGN', 'AGN', 'AM', 'BC', 'BA', 'TA', 'TDA', 'TWA', 'AWR', 'WL', 'TP', 'PERE', 'TN', 'TDC', 'TWC',  'ISOC', 'BCBA', 'PWL', 'WWL', 'SAWL', 'MAWL', 'AWL', 'PKVC', 'AUP', 'AFP', 'S', 'PMWL', 'PW1WL', 'PPC', 'PCC', 'PSMC', 'PMAC', 'PAC', 'LTP'],
                reportHeaders: [],
                needResetHeaders: false,
                obj_Post: {
                    SelectedBrands1: null
                },
                bool_isDDMV: false,
                backURL: null,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            getAgentGroup(loadReport = false) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.ddAgentList = that.deepClone(d.dropdownlist);
                            that.ddAgentList2 = that.deepClone(d.dropdownlist);

                            if (that.ddAgentList.length > 0) {
                                that.disableAgentGroupLevel();
                            }
                            if (that.ddAgentList2.length > 0) {
                                that.selectAgentGroup2Level();
                            }
                            if (loadReport) {
                                that.getReportList();
                            }
                        }
                    });
            },
            disableAgentGroupLevel() {
                var that = this;
                if (that.selectedAgent != null && that.selectedAgent.length > 0) {
                    var selectedAgent = that.selectedAgent[0].split("-")[0];
                    for (var j = 0; j < that.ddAgentList.length; j++) {
                        var itemLevel = that.ddAgentList[j].id.split("-")[0];

                        if (selectedAgent != itemLevel && itemLevel == "0") {
                            that.ddAgentList[j].isDisabled = true;
                        }

                        if (that.ddAgentList[j].children && that.ddAgentList[j].children.length > 0) {
                            for (var k = 0; k < that.ddAgentList[j].children.length; k++) {
                                var itemLevel1 = that.ddAgentList[j].children[k].id.split("-")[0];

                                if (selectedAgent != itemLevel1 && itemLevel1 == "1") {
                                    that.ddAgentList[j].children[k].isDisabled = true;
                                }

                                if (that.ddAgentList[j].children[k].children && that.ddAgentList[j].children[k].children.length > 0) {
                                    for (var l = 0; l < that.ddAgentList[j].children[k].children.length; l++) {
                                        var itemLevel2 = that.ddAgentList[j].children[k].children[l].id.split("-")[0];

                                        if (selectedAgent != itemLevel2 && itemLevel2 == "2") {
                                            that.ddAgentList[j].children[k].children[l].isDisabled = true;
                                        }

                                        if (that.ddAgentList[j].children[k].children[l].children && that.ddAgentList[j].children[k].children[l].children.length > 0) {
                                            for (var m = 0; m < that.ddAgentList[j].children[k].children[l].children.length; m++) {
                                                var itemLevel3 = that.ddAgentList[j].children[k].children[l].children[m].id.split("-")[0];

                                                if (selectedAgent != itemLevel3 && itemLevel3 == "3") {
                                                    that.ddAgentList[j].children[k].children[l].children[m].isDisabled = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    that.searchAgent2Main = that.selectedAgent;
                    that.searchAgent2 = [];
                    that.searchAgT = 0;
                }
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                            that.ddAgentList2 = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                            that.ddAgentList2 = null;
                            that.searchAgT = 0;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                //if (value) {
                //    this.setSearchCriteriaAGI(value);
                //}
                //else {
                //    this.setSearchCriteriaAGI(null);
                //}

                //this.searchAgi = 0;
                //this.searchAgT = null;
                //if (value) {
                //    var agentList = value.split("-");
                //    this.searchAgi = agentList[agentList.length - 1];
                //    this.searchAgT = agentList[agentList.length - 2];
                //}
                if (value && value.length > 0) {
                    var agentList = value[0].split("-");
                    this.searchAgT = agentList[agentList.length - 2];
                }

                var temp = "";
                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.searchAgi = temp;
                this.ddCurrencyListFilter = null;
                this.searchCurrencyFilter = null;
                this.selectedAgent = value;
                this.searchAgent2Main = value;
                this.getAgentGroup();
            },
            selectAgentGroup2Level() {
                var that = this;
                that.searchAgent2 = [];

                for (var h = 0; h < that.searchAgent2Main.length; h++) {
                    that.searchAgent2.push(that.searchAgent2Main[h]);
                    var currentAgent = that.searchAgent2Main[h];
                    var selectedAgentLevel = that.searchAgent2Main[h].split("-")[0];
                    for (var j = 0; j < that.ddAgentList2.length; j++) {
                        var itemLevel = that.ddAgentList2[j].id.split("-")[0];

                        if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel)) {
                            this.searchAgent2.push(that.ddAgentList2[j].id);
                        }

                        if (that.ddAgentList2[j].children && that.ddAgentList2[j].children.length > 0) {
                            for (var k = 0; k < that.ddAgentList2[j].children.length; k++) {
                                var itemLevel1 = that.ddAgentList2[j].children[k].id.split("-")[0];

                                if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel1)) {
                                    if (currentAgent == that.ddAgentList2[j].id) {
                                        this.searchAgent2.push(that.ddAgentList2[j].children[k].id);
                                    }
                                }

                                if (that.ddAgentList2[j].children[k].children && that.ddAgentList2[j].children[k].children.length > 0) {
                                    for (var l = 0; l < that.ddAgentList2[j].children[k].children.length; l++) {
                                        var itemLevel2 = that.ddAgentList2[j].children[k].children[l].id.split("-")[0];

                                        if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel2)) {
                                            if (currentAgent == that.ddAgentList2[j].id ||
                                                currentAgent == that.ddAgentList2[j].children[k].id) {
                                                this.searchAgent2.push(that.ddAgentList2[j].children[k].children[l].id);
                                            }
                                        }

                                        if (that.ddAgentList2[j].children[k].children[l].children && that.ddAgentList2[j].children[k].children[l].children.length > 0) {
                                            for (var m = 0; m < that.ddAgentList2[j].children[k].children[l].children.length; m++) {
                                                var itemLevel3 = that.ddAgentList2[j].children[k].children[l].children[m].id.split("-")[0];

                                                if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel3)) {
                                                    if (currentAgent == that.ddAgentList2[j].id ||
                                                        currentAgent == that.ddAgentList2[j].children[k].id ||
                                                        currentAgent == that.ddAgentList2[j].children[k].children[l].id) {
                                                        this.searchAgent2.push(that.ddAgentList2[j].children[k].children[l].children[m].id);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                var temp2 = "";
                for (var x = 0; x < this.searchAgent2.length; x++) {
                    if (x != 0) {
                        temp2 += ",";
                    }
                    var split = this.searchAgent2[x].split("-");

                    if (split.length == 2) {
                        temp2 += split[1];
                    }
                    else {
                        temp2 += split[0];
                    }
                }
                this.searchAgi2 = temp2;
            },
            loadSearchMemberCurrencyOptions({ action, callback, instanceId }) {
                var that = this;

                if (!this.searchAgi2) {
                    this.searchAgi2 = 0;
                }

                //this.getDataApi(`/api/dd/currency/${this.searchAgi2}`,
                this.obj_Post.SelectedBrands1 = this.searchAgi2;

                this.postDataApi(`/api/dd/curbyagilist/1`, this.obj_Post,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyListFilter = d.dropdownlist;
                            // if (that.ddCurrencyListFilter.length > 0) {
                            //     if (localStorage.getItem('CCUSD') != "") {
                            //         for (var i = 0; i < that.ddCurrencyListFilter.length; i++) {
                            //             if (that.ddCurrencyListFilter[i].id == localStorage.getItem('CCUSD')) {
                            //                 that.searchCurrencyFilter = that.ddCurrencyListFilter[i].id;
                            //                 break;
                            //             }
                            //         }
                            //     }
                            // }
                        }
                        else {
                            that.ddCurrencyListFilter = null;
                        }
                        callback();
                    });
            },
            selectGameProvider(value, instanceId) {

            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                d.dropdownlist[j].label = that.renderCategory(d.dropdownlist[j].id.slice(d.dropdownlist[j].id.indexOf('-') + 1));
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            getCategory() {
                for (var i = 0; i < this.ddGameProviderList.length; i++) {
                    this.ddGameProviderList[i].label = this.renderCategory(this.ddGameProviderList[i].id.slice(ddGameProviderList[i].id.indexOf('-') + 1));
                }
            },
            newsearch() {
                this.$refs.search.focus();
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;
                //var agentGId = null;
                //var agentT = null;

                //if (this.searchAgi > 0) {
                //    agentGId = this.searchAgi;
                //}
                //if (this.searchAgT != null) {
                //    agentT = this.searchAgT;
                //}

                //var path = '';
                // var path = this.getListingParamQuery(null, null, this.str_tableSortBy, this.bool_isSort);
                var param = {
                    "s": this.str_tableSortBy,
                    "d": this.bool_isSort,
                    "f": {
                        "AGI_csv": (this.searchAgi2 != 0) ? this.searchAgi2 : "",
                        "AGT": (this.searchAgT != null) ? this.searchAgT : 0,
                        "GPI_csv": (_.toString(this.searchGameProviderId) == "") ? null : _.toString(this.searchGameProviderId),
                        "CI": (this.searchCurrency && this.bool_firstLogin == true) ? this.searchCurrency : (localStorage.getItem('CCUSD') != "" && this.bool_firstLogin == false) ? localStorage.getItem('CCUSD') : "",
                        "STS_from": (this.searchCreatedTS.startDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.startDate) : "",
                        "STS_to": (this.searchCreatedTS.endDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.endDate) : "",
                        "MI": this.searchUserId,
                        "RI": this.searchReferralUserId,
                        "RSN": this.searchRegisterSourceName,
                        "CIF": this.searchCurrencyFilter
                    }
                }

                sessionStorage.setItem('TWLBAG_FilterAGI', '');
                sessionStorage.setItem('TWLBAG_FilterAgent', '');
                sessionStorage.setItem('TWLBAG_FilterMI', '');
                sessionStorage.setItem('TWLBAG_FilterRI', '');
                sessionStorage.setItem('TWLBAG_FilterGPI', '');
                sessionStorage.setItem('TWLBAG_FilterCI', '');
                sessionStorage.setItem('TWLBAG_FilterCIF', '');
                sessionStorage.setItem('TWLBAG_FilterSTS_from', '');
                sessionStorage.setItem('TWLBAG_FilterSTS_to', '');
                if (this.searchAgi2) {
                   // path += "&f.AGI_csv=" + this.searchAgi2;
                    this.pre_searchAgi = this.searchAgi2;
                    sessionStorage.setItem('TWLBAG_FilterAGI', this.searchAgi2);
                    sessionStorage.setItem('TWLBAG_FilterAgent', this.searchAgent2Main);
                }
                else {
                    this.pre_searchAgi = 0;
                }
                if (this.searchAgT != null) {
                   // path += "&f.AGT=" + this.searchAgT;
                    this.pre_searchAgT = this.searchAgT;
                }

                if (this.searchUserId) {
                   // path += "&f.MI=" + this.searchUserId;
                    sessionStorage.setItem('TWLBAG_FilterMI', this.searchUserId);
                    sessionStorage.setItem('TWLBAG_FilterMName', this.searchUsername);
                }

                if (this.searchReferralUserId) {
                   // path += "&f.RI=" + this.searchReferralUserId;
                    sessionStorage.setItem('TWLBAG_FilterRI', this.searchReferralUserId);
                    sessionStorage.setItem('TWLBAG_FilterRName', this.searchUsername);
                }

                if (this.searchGameProviderId) {
                    //path += "&f.GPI=" + this.searchGameProviderId;
                   // path += "&f.GPI_csv=" + this.searchGameProviderId;
                    sessionStorage.setItem('TWLBAG_FilterGPI', this.searchGameProviderId);

                }

                //if (this.searchGameCategoryIds) {
                    //path += "&f.GCI_csv=" + this.searchGameCategoryIds;
               // }

                if (this.searchCurrency && this.bool_firstLogin == true) {
                  //  path += "&f.CI=" + this.searchCurrency;
                    sessionStorage.setItem('TWLBAG_FilterCI', this.searchCurrency);
                }
                else if (localStorage.getItem('CCUSD') != "" && this.bool_firstLogin == false) {
                   // path += "&f.CI=" + localStorage.getItem('CCUSD');
                    sessionStorage.setItem('TWLBAG_FilterCI', localStorage.getItem('CCUSD'));
                    this.bool_firstLogin = true;
                }
                //if (this.searchRegisterSourceName) {
                    //path += "&f.RSN=" + this.searchRegisterSourceName;
                //}

                if (this.searchCurrencyFilter) {
                    //path += "&f.CIF=" + this.searchCurrencyFilter;
                    sessionStorage.setItem('TWLBAG_FilterCIF', this.searchCurrencyFilter);
                }

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        //path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        sessionStorage.setItem('TWLBAG_FilterSTS_from', this.parseDateToJsonString(this.searchCreatedTS.startDate));
                    }
                    if (this.searchCreatedTS.endDate != "") {
                       // path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                        sessionStorage.setItem('TWLBAG_FilterSTS_to', this.parseDateToJsonString(this.searchCreatedTS.endDate));
                    }
                }


                // if (path) {
                //     path = path.substring(1);
                // }

                this.postDataApi(`/api/reports/winloss/totalbag`, param,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.sc_userid = that.searchUserId;                            
                            that.sc_username = that.searchUsername;
                            that.sc_daterange = that.searchCreatedTS;
                            that.sc_cur = that.searchCurrency;
                            that.sc_curf = that.searchCurrencyFilter;
                            that.sc_agi = that.searchAgi2;
                            that.sc_agent = that.searchAgent2Main;                            

                            if (d.R1) {
                                var temp_providerName = null;
                                var temp_currencyISOC = null;
                                for (var i = 0; i < d.R1.length; i++) {
                                    if (temp_providerName == d.R1[i].PN && temp_currencyISOC == d.R1[i].ISOC) {
                                        temp_providerName = d.R1[i].PN;
                                        temp_currencyISOC = d.R1[i].ISOC;
                                        d.R1[i].PN = null;
                                    }
                                    else {
                                        temp_providerName = d.R1[i].PN;
                                        temp_currencyISOC = d.R1[i].ISOC;
                                    }

                                    if (d.R1[i].ICT)
                                        that.repoerIsCrypto = d.R1[i].ICT;
                                }
                            }
                            //for (var i = 0; i < d.R2.length; i++) {
                            //    if (d.R2[i].AWL != null && d.R2[i].MAWL != null && d.R2[i].SAWL != null) {
                            //        d.R2[i].AWL = d.R2[i].AWL.toFixed(3).slice(0, -1);
                            //        d.R2[i].MAWL = d.R2[i].MAWL.toFixed(3).slice(0, -1);
                            //        d.R2[i].SAWL = d.R2[i].SAWL.toFixed(3).slice(0, -1);
                            //    }

                            //    if (d.R2[i].WWL != null && d.R2[i].PWL != null && d.R2[i].WLA != null) {
                            //        d.R2[i].WWL = d.R2[i].WWL.toFixed(3).slice(0, -1);
                            //        d.R2[i].PWL = d.R2[i].PWL.toFixed(3).slice(0, -1);
                            //        d.R2[i].WLA = d.R2[i].WLA.toFixed(3).slice(0, -1);
                            //    }

                            //    if (d.R2[i].BA != null && d.R2[i].TA != null) {
                            //        d.R2[i].BA = d.R2[i].BA.toFixed(3).slice(0, -1);
                            //        d.R2[i].TA = d.R2[i].TA.toFixed(3).slice(0, -1);
                            //    }
                            //    d.R2[i].TDA = d.R2[i].TDA.toFixed(3).slice(0, -1);
                            //    d.R2[i].TWA = d.R2[i].TWA.toFixed(3).slice(0, -1);

                            //}
                            //for (var i = 0; i < d.R1.length; i++) {
                            //    if (d.R1[i].AWL != null && d.R1[i].MAWL != null && d.R1[i].SAWL != null) {
                            //        d.R1[i].AWL = d.R1[i].AWL.toFixed(3).slice(0, -1);
                            //        d.R1[i].MAWL = d.R1[i].MAWL.toFixed(3).slice(0, -1);
                            //        d.R1[i].SAWL = d.R1[i].SAWL.toFixed(3).slice(0, -1);
                            //    }

                            //    if (d.R1[i].WWL != null && d.R1[i].PWL != null && d.R1[i].WLA != null) {
                            //        d.R1[i].WWL = d.R1[i].WWL.toFixed(3).slice(0, -1);
                            //        d.R1[i].PWL = d.R1[i].PWL.toFixed(3).slice(0, -1);
                            //        d.R1[i].WLA = d.R1[i].WLA.toFixed(3).slice(0, -1);
                            //    }

                            //    if (d.R1[i].BA != null && d.R1[i].TA != null) {
                            //        d.R1[i].BA = d.R1[i].BA.toFixed(3).slice(0, -1);
                            //        d.R1[i].TA = d.R1[i].TA.toFixed(3).slice(0, -1);
                            //    }
                            //    d.R1[i].TDA = d.R1[i].TDA.toFixed(3).slice(0, -1);
                            //    d.R1[i].TWA = d.R1[i].TWA.toFixed(3).slice(0, -1);
                            //}
                            that.arr_reportList = d.R1;

                            that.arr_reportTotalList = d.R2;

                            that.resizeTableHead();
                        }
                    });

            },
            saveToExcel() {

                this.bool_fullLoading = false;
                var that = this;
                //var agentGId = null;
                //var agentT = null;

                var param = {
                    "s": this.str_tableSortBy,
                    "d": this.bool_isSort,
                    "f": {
                        "AGI_csv": (this.searchAgi2 != 0) ? this.searchAgi2 : "",
                        "AGT": (this.searchAgT != null) ? this.searchAgT : 0,
                        "GPI_csv": (_.toString(this.searchGameProviderId) == "") ? null : _.toString(this.searchGameProviderId),
                        "CI": (this.searchCurrency && this.bool_firstLogin == true) ? this.searchCurrency : (localStorage.getItem('CCUSD') != "" && this.bool_firstLogin == false) ? localStorage.getItem('CCUSD') : "",
                        "STS_from": (this.searchCreatedTS.startDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.startDate) : "",
                        "STS_to": (this.searchCreatedTS.endDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.endDate) : "",
                        "MI": this.searchUserId,
                        "RI": this.searchRegisterSourceName,
                        "RSN": this.searchReferralUserId,
                        "CIF": this.searchCurrencyFilter
                    }
                }
                var form = document.createElement("form");
                form.method = "POST";
                form.action = "/api/reports/winlossexcel/totalbag";
                form.target = "_blank";

                for (var key in param) {
                    if (param.hasOwnProperty(key) && key == "f") {
                        for (var fkey in param['f']) {
                            var hiddenField = document.createElement('input');
                            hiddenField.type = "hidden";
                            hiddenField.name = key + '[' + fkey + ']'
                            hiddenField.value = param['f'][fkey];
                            form.appendChild(hiddenField);
                        }
                    }
                    else if (param.hasOwnProperty(key)) {
                        var hiddenField = document.createElement('input');
                        hiddenField.type = "hidden";
                        hiddenField.name = key;
                        hiddenField.value = param[key];
                        form.appendChild(hiddenField);
                    }
                }

                document.body.appendChild(form);
                form.submit();
                //if (this.searchAgi > 0) {
                //    agentGId = this.searchAgi;
                //}
                //if (this.searchAgT != null) {
                //    agentT = this.searchAgT;
                //}
                //var path = '';
                //var path = this.getListingParamQuery(null, null, this.str_tableSortBy, this.bool_isSort);

                //if (this.searchAgi2) {
                //    path += "&f.AGI_csv=" + this.searchAgi2;
                //    this.pre_searchAgi = this.searchAgi2;
                //}
                //else {
                //    this.pre_searchAgi = 0;
                //}
                //if (this.searchAgT != null) {
                //    path += "&f.AGT=" + this.searchAgT;
                //    this.pre_searchAgT = this.searchAgT;
                //}

                //if (this.searchUserId) {
                //    path += "&f.MI=" + this.searchUserId;
                //}

                //if (this.searchReferralUserId) {
                //    path += "&f.RI=" + this.searchReferralUserId;
                //}

                //if (this.searchGameProviderId) {
                //    //path += "&f.GPI=" + this.searchGameProviderId;
                //    path += "&f.GPI_csv=" + this.searchGameProviderId;
                //}

                //if (this.searchGameCategoryIds) {
                //    path += "&f.GCI_csv=" + this.searchGameCategoryIds;
                //}

                //if (this.searchCurrency && this.bool_firstLogin == true) {
                //    path += "&f.CI=" + this.searchCurrency;
                //}
                //else if (localStorage.getItem('CCUSD') != "" && this.bool_firstLogin == false) {
                //    path += "&f.CI=" + localStorage.getItem('CCUSD');
                //    this.bool_firstLogin = true;
                //}

                //if (this.searchCurrencyFilter) {
                //    path += "&f.CIF=" + this.searchCurrencyFilter;
                //}

                //if (this.searchRegisterSourceName) {
                //    path += "&f.RSN=" + this.searchRegisterSourceName;
                //}

                //if (this.searchCreatedTS) {
                //    if (this.searchCreatedTS.startDate != "") {
                //        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                //    }
                //    if (this.searchCreatedTS.endDate != "") {
                //        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                //    }
                //}


                //// if (path) {
                ////     path = path.substring(1);
                //// }

                //window.open('/api/reports/winlossexcel/totalbag?' + path, '_blank');
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                   // this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi2}`,
                    this.obj_Post.SelectedBrands1 = this.searchAgi2;

                    this.postDataApi(`/api/dd/mreferralbypost/${searchQuery}`, this.obj_Post,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            selectMemberOptions(node, instanceId) {
                if (this.ddMemberList && this.ddMemberList.length > 0) {
                    var index = -1;
                    for (var i = 0; i < this.ddMemberList.length; i++) {
                        if (this.ddMemberList[i].id == node) {
                            this.searchUsername = this.ddMemberList[i].label;
                            break;
                        }
                    }
                }
                else {
                    this.searchUsername = null;
                }
            },
            deSelectMemberOptions(node, instanceId) {
                this.searchUserId = null;
                this.searchUsername = null;
            },
            loadReferralMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddReferralMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                   // this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi2}`,
                    this.obj_Post.SelectedBrands1 = this.searchAgi2;

                    this.postDataApi(`/api/dd/mreferralbypost/${searchQuery}`, this.obj_Post,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddReferralMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddReferralMemberList = [];
                            }

                            callback(null, that.ddReferralMemberList);
                        });
                }
            },
            selectReferralMemberOptions(node, instanceId) {
                // this.searchAgi = node.agi;
            },
            deSelectReferralMemberOptions(node, instanceId) {
                this.searchReferralUserId = null;
                this.searchReferralUsername = null;
            },
            openWinLossDetail(data) {

            },
            loadCurrencyOptions() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                            that.str_showDetails = (that.str_showDetails ? that.str_showDetails : that.ddCurrencyList[i].label);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                        }

                    });
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);
                }
            },
            // totalAGNett(data) {
            //     var result = data.AWL;
            //     try {
            //         var ag = parseFloat(data.AWL);
            //         var tp = parseFloat(data.TP);
            //         result = ag - tp;
            //     }
            //     catch (err) {
            //         console.log(err);
            //     }
            //     return result;
            // },
            formatPT(data) {
                var result = '';
                if (data.SSADPT < 2) {
                    data.PPT = data.PPT + data.SSADPT - 2;
                    data.SSADPT = 2;
                }

                switch (this.getUserInfo.AT) {
                    case 0:
                        // var PLA = 100 - this.formatNumber(data.WLS) - this.formatNumber(data.SAWLS) - this.formatNumber(data.MAWLS) - this.formatNumber(data.AWLS);
                        result = this.formatNumber(data.PPT) +
                            "/" + this.formatNumber(data.SSADPT) +
                            "/" + this.formatNumber(data.SADPT) +
                            "/" + this.formatNumber(data.MADPT) +
                            "/" + this.formatNumber(data.ADPT);

                        this.shareIndicator = this.getLanguage['WLRPT']['PRV'] +
                            "/" + this.getLanguage['WLRPT']['CO'] +
                            "/" + this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 1:
                        result = this.formatNumber(data.SADPT) +
                            "/" + this.formatNumber(data.MADPT) +
                            "/" + this.formatNumber(data.ADPT);

                        this.shareIndicator = this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 2:
                        result = this.formatNumber(data.MADPT) +
                            "/" + this.formatNumber(data.ADPT);

                        this.shareIndicator = this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 3:
                        result = this.formatNumber(data.ADPT);
                        this.shareIndicator = this.getLanguage['WLRPT']['AG'];
                        break;
                }

                return result;
            },
            ShowDetails(currency) {
                if (this.str_showDetails != currency) {
                    this.str_showDetails = currency;
                    this.bool_showDetails = true;
                    sessionStorage.setItem('TWLBAG_Filter_ISOC', currency);
                }
                else {
                    this.bool_showDetails = !this.bool_showDetails;
                }
                this.resizeTableHead();
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getMonthStartDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            //setSortTable(SV) { //SV = Sort Value
            //    // this.int_Page = 1;
            //    // this.int_IC = 1;
            //    this.str_tableSortBy = SV;
            //    this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
            //    console.log("testing123: ", SV)
            //    //this.getReportList();
            //},
            setSortTable(SV) {//SV = Sort Value
                if (this.str_tableSortBy !== SV) {
                    this.str_tableSortBy = SV;
                    if (this.defaultDescendingColumns.includes(SV)) {
                        this.bool_isSort = true;
                    } else {
                        this.bool_isSort = false;
                    }
                } else {
                    this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                }

                // this.getReportList();
            },

            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            //getAGNWL(data)
            //{
            //     var AGNWL = 0;
            //     AGNWL = this.formatNumber(data.AWL) - this.formatNumber(data.TP);

            //      return AGNWL;
            // },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(3) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getLinkUrl() {
                var link = '/R/NTWL';
                sessionStorage.setItem(link, this.$route.path);
                return link;
            },
            renderBackgroundColor(header) {
                if (header == 'PMWL' || header == 'PW1WL' || header == 'PPC' || header == 'PCC' || header == 'PSMC' || header == 'PMAC' || header == 'PAC' || header == 'LTP') {
                    return "background: #004698 !important;";
                } else if (header == 'TN') {
                    return "background: #562c87 !important;";
                } else if (header == 'TDC' || header == 'TDA') {
                    return "background: rgb(26, 90, 13) !important;";
                } else if (header == 'TWC' || header == 'TWA') {
                    return "background: rgb(129, 10, 10) !important;";
                }
            },
            renderClassName(header, data) {
                if ((header == 'AUP' && data && data.AUP >= 0) || (header == 'LTP' && data && data.LTP >= 0) || (header == 'AFP' && data && data.AFP >= 0)) {
                    return "tableCtnRight positive-number";
                } else if ((header == 'AUP' && data && data.AUP < 0) || (header == 'LTP' && data && data.LTP < 0) || (header == 'AFP' && data && data.AFP < 0)) {
                    return "tableCtnRight negative-number";
                } else if (header == 'TN' && data && data.TN >= 0) {
                    return "tableCtnRight positive-number winlossBg";
                } else if (header == 'TN' && data && data.TN < 0) {
                    return "tableCtnRight negative-number winlossBg";
                } else if ((header == 'TP' && data && data.TP <= 0)) {
                    return "tableCtnRight positive-number";
                } else if ((header == 'TP' && data && data.TP > 0)) {
                    return "tableCtnRight negative-number";
                } else if (header == 'AUP' || header == 'LTP' || header == 'AFP' || header == 'TN' || header == 'TP' || header == 'PERE' || header == 'AM' || header == 'BC' || header == 'BCBA' || header == 'BA' || header == 'TA' || header == 'WL' || header == 'PWL' || header == 'WWL' || header == 'SAWL' || header == 'MAWL' || header == 'AWL' || header == 'PMWL' || header == 'PW1WL' || header == 'PPC' || header == 'PCC' || header == 'PSMC' || header == 'PMAC' || header == 'PAC' || header == 'S' || header == 'AWR') {
                    return "tableCtnRight";
                } else if (header == 'TDC' || header == 'TDA') {
                    return "tableCtnRight depositBg specialRow";
                } else if (header == 'TWC') {
                    return "tableCtnRight withdrawBg specialRow";
                } else if (header == 'TWA') {
                    return "tableCtnRight negative-number withdrawBg specialRow";
                }
               
            },
            resetColumn(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn('AGN')
                }
                if (!that.repoerIsCrypto) {
                    that.removeDefaultColumn('BCBA')
                }
                if (that.getUserInfo.AT >= 1) {
                    that.removeDefaultColumn('SAWL')
                    that.removeDefaultColumn('PSMC')
                }
                if (that.getUserInfo.AT >= 2) {
                    that.removeDefaultColumn('MAWL')
                    that.removeDefaultColumn('PMAC')
                }
                if (that.getUserInfo.AT >= 3) {
                    that.removeDefaultColumn('AWL')
                    that.removeDefaultColumn('PAC')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            MarginCal(winloss, turnover) {
                let formatWinloss = this.formatNumber(winloss);
                let formatTurnover = this.formatNumber(turnover);
                formatWinloss = Number(formatWinloss.toString().replaceAll(',', ''));
                formatTurnover = Number(formatTurnover.toString().replaceAll(',', ''));
                if (formatWinloss === 0 && formatTurnover === 0) {
                    return 0;
                }
                let result = (formatWinloss / formatTurnover) * -100;
                if (result === 0) {
                    return 0;
                }
                return result;
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
            sortedReportList() {
                const list = Array.isArray(this.arr_reportList) ? this.arr_reportList : [];
                const sortField = this.str_tableSortBy;
                const sortOrder = this.bool_isSort;
                console.log("testing13: ", sortField)
                console.log("testing13a: ", list)
                return list.slice().sort((a, b) => {

                    let valA, valB;
                    if (sortField === 'WL') {
                        valA = a['WLA'];
                        valB = b['WLA'];
                    }
                    else if (sortField === 'AWR') {
                        let aSpecial = (!this.searchGameProviderId.includes('43') && !this.searchGameProviderId.includes('113') && a.TA > 0);
                        let bSpecial = (!this.searchGameProviderId.includes('43') && !this.searchGameProviderId.includes('113') && b.TA > 0);

                        if (aSpecial && !bSpecial) {
                            return 1;
                        }
                        if (bSpecial && !aSpecial) {
                            return -1;
                        }
                        valA = this.MarginCal(a['WLA'], a['TA']);
                        valB = this.MarginCal(b['WLA'], b['TA']);
                    }
                    else {
                        valA = a[sortField];
                        valB = b[sortField];
                    }
                    if (!isNaN(parseFloat(valA)) && !isNaN(parseFloat(valB))) {
                        valA = parseFloat(valA);
                        valB = parseFloat(valB);
                    } else if (sortField === 'PERE') {
                        valA = (a['TP'] && a['WLA']) ? (a['TP'] / a['WLA']) * -100 : 0;
                        valB = (b['TP'] && b['WLA']) ? (b['TP'] / b['WLA']) * -100 : 0;
                    } else if (sortField === 'GC') {
                        // 组合 CN 与 PN 到一个数组中，再连接成字符串作为比较值
                        const combinedA = [a['CN'] || '', a['PN'] || ''].join(' ');
                        const combinedB = [b['CN'] || '', b['PN'] || ''].join(' ');
                        valA = combinedA.toUpperCase();
                        valB = combinedB.toUpperCase();
                    } else {
                        console.log("testing13c: ")
                        valA = String(valA).toUpperCase();
                        valB = String(valB).toUpperCase();
                    }
                    if (valA < valB) {
                        return this.bool_isSort ? 1 : -1;
                    } else if (valA > valB) {
                        return this.bool_isSort ? -1 : 1;
                    } else {
                        return 0;
                    }
                });
            },
            sortedReportTotalList() {
                const list = Array.isArray(this.arr_reportTotalList) ? this.arr_reportTotalList : [];
                const sortField = this.str_tableSortBy;
                return list.slice().sort((a, b) => {
                    let valA, valB;
                    if (sortField === 'WL') {
                        valA = a['WLA'];
                        valB = b['WLA'];
                    }
                    else if (sortField === 'AWR') {
                        valA = this.MarginCal(a['WLA'], a['TA']);
                        valB = this.MarginCal(b['WLA'], b['TA']);
                    }
                    else {
                        valA = a[sortField];
                        valB = b[sortField];
                    }
                    if (!isNaN(parseFloat(valA)) && !isNaN(parseFloat(valB))) {
                        valA = parseFloat(valA);
                        valB = parseFloat(valB);
                    } else {
                        valA = String(valA).toUpperCase();
                        valB = String(valB).toUpperCase();
                    }

                    if (valA < valB) {
                        return this.bool_isSort ? -1 : 1;
                    } else if (valA > valB) {
                        return this.bool_isSort ? 1 : -1;
                    } else {
                        return 0;
                    }
                });
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS1';
            this.$parent.showActiveMenu = 'R.TWLBAG';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.hide = this.getUserInfo.SBSA;
            if (this.$route.query.back && this.$route.query.back == 1) {
                var FilterAGI = sessionStorage.getItem('TWLBAG_FilterAGI');
                var FilterAgent = sessionStorage.getItem('TWLBAG_FilterAgent');
                if (FilterAGI && FilterAgent) {
                    //var that = this;
                    this.searchAgi = FilterAGI;
                    this.searchAgi2 = FilterAGI;
                    this.searchAgent = FilterAgent.split(',');
                    this.searchAgent = Array.isArray(this.searchAgent) ? this.searchAgent : [this.searchAgent];
                    //this.getDataApi(`/api/dd/ag/1/0/1`,
                    //    function (d, s) {
                    //        if (s && d && d.dropdownlist) {
                    //            that.ddAgentList = d.dropdownlist;
                    //        }
                    //    });
                }
                var FilterGPI = sessionStorage.getItem('TWLBAG_FilterGPI');
                if (FilterGPI) {
                    this.searchGameProviderId = FilterGPI.split(',');
                }

                var FilterMI = sessionStorage.getItem('TWLBAG_FilterMI');
                var FilterMName = sessionStorage.getItem('TWLBAG_FilterMName');
                if (FilterMI && FilterMName) {
                    this.searchUserId = FilterMI;
                    this.searchUsername = FilterMName;
                    this.ddDefaultMemberList = [
                        { id: this.searchUserId, label: this.searchUsername }
                    ];
                }

                var FilterRI = sessionStorage.getItem('TWLBAG_FilterRI');
                var FilterRName = sessionStorage.getItem('TWLBAG_FilterRName');
                if (FilterRI && FilterRName) {
                    this.searchReferralUserId = FilterRI;
                    this.searchReferralUsername = FilterRName;
                    this.ddReferralDefaultMemberList = [
                        { id: this.searchUserId, label: this.searchUsername }
                    ];
                }

                var FilterCI = sessionStorage.getItem('TWLBAG_FilterCI');
                if (FilterCI) {
                    this.searchCurrency = FilterCI;
                }

                var FilterCIF = sessionStorage.getItem('TWLBAG_FilterCIF');
                if (FilterCIF) {
                    this.searchCurrencyFilter = FilterCIF;
                }

                var FilterSTS_from = sessionStorage.getItem('TWLBAG_FilterSTS_from');
                if (FilterSTS_from) {
                    this.searchCreatedTS.startDate = FilterSTS_from;
                }

                var FilterSTS_to = sessionStorage.getItem('TWLBAG_FilterSTS_to');
                if (FilterSTS_to) {
                    this.searchCreatedTS.endDate = FilterSTS_to;
                }

                //this.getReportList();
            } else {
                //if (this.$route.query.agit) {
                //    this.searchAgent = [this.$route.query.agit];
                //    this.searchAgi = this.$route.query.agit.split("-")[1];
                //    this.searchAgi2 = this.$route.query.agit.split("-")[1] ;
                //}
                if (this.$route.query.sagi && this.$route.query.sagi != 0) {
                    this.searchAgent = this.$route.query.sagi;
                    if (this.$route.query.agi && this.$route.query.agi != 0) {
                        this.searchAgi = this.$route.query.agi;
                    }
                    this.searchAgent = Array.isArray(this.searchAgent) ? this.searchAgent : [this.searchAgent];
                }

                if (this.$route.query.gpi) {
                    this.searchGameProviderId = ($.isArray(this.$route.query.gpi) ? this.$route.query.gpi : [this.$route.query.gpi]);
                }
                
                if (this.$route.query.convert) {
                    this.searchCurrency = this.$route.query.convert;
                }else if (this.$route.query.cur) {
                    this.searchCurrency = this.$route.query.cur;
                }

                if (this.$route.query.fcur) {
                    this.searchCurrencyFilter = this.$route.query.fcur;
                } else if (this.$route.query.curf) {
                    this.searchCurrencyFilter = this.$route.query.curf;
                }

                if (this.$route.query.df) {
                    this.searchCreatedTS.startDate = this.$route.query.df;
                }

                if (this.$route.query.dt) {
                    this.searchCreatedTS.endDate = this.$route.query.dt;
                }

                if (this.$route.query.desc) {
                    this.bool_isSort = this.$route.query.desc == 0 ? false : true;
                    this.str_tableSortBy = "TN"
                }
                if (this.$route.query.i && this.$route.query.u) {
                    this.ddDefaultMemberList = [
                        { id: this.$route.query.i, label: this.$route.query.u }
                    ];
                }
                //if (this.$route.query.magi && this.$route.query.magi != 0) {
                //    var magi = this.$route.query.magi;

                //    var that = this;
                //    this.getDataApi(`/api/dd/agilist/` + magi,
                //        function (d, s) {
                //            if (s && d) {
                //                that.searchAgi = d.toString();
                //                that.searchAgi2 = d.toString();
                //                that.searchAgent = [];
                //                let AgentList = that.searchAgi.split(',');
                //                for (var i = 0; i < AgentList.length; i++) {
                //                    that.searchAgent.push('3-' + AgentList[i]);
                //                }
                //                that.selectAgentOptions(that.searchAgent);
                //            }
                //            else {
                //                that.searchAgent = null;
                //                that.searchAgi = null;
                //            }
                //            that.getReportList();
                //        });
                //}
                if (this.$route.query.as == 't') {
                    this.bool_showDetails = true;
                }
            }

            this.setSortLogo("TN")
            this.loadCurrencyOptions();
            if (this.$route.path != this.$route.fullPath) {
                this.bool_showDetails = true;
                this.str_showDetails = (this.str_showDetails ? this.str_showDetails : sessionStorage.getItem('TWLBAG_Filter_ISOC'));
                this.backURL = sessionStorage.getItem(this.$route.path);
                if (this.searchAgent) {
                    this.selectedAgent = this.searchAgent;
                    this.searchAgent2Main = this.searchAgent;
                    this.getAgentGroup(true);
                } else {
                    this.getReportList();
                }
                //this.getReportList();
            } else {
                sessionStorage.setItem(this.$route.path, '');
            }
        },
        watch: {
            getLanguage() {
                //this.getReportList();
                this.getCategory();
                
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/NetWinLoss`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                if (that.hideBrand) {
                                    that.removeDefaultColumn('AGN')
                                    that.removeColumn('AGN')
                                }
                                if (!that.repoerIsCrypto) {
                                    that.removeDefaultColumn('BCBA')
                                    that.removeColumn('BCBA')
                                }
                                if (that.getUserInfo.AT >= 1) {
                                    that.removeDefaultColumn('SAWL')
                                    that.removeDefaultColumn('PSMC')
                                    that.removeDefaultColumn('SAGN')
                                    that.removeColumn('SAWL')
                                    that.removeColumn('PSMC')
                                    that.removeColumn('SAGN')
                                }
                                if (that.getUserInfo.AT >= 2) {
                                    that.removeDefaultColumn('MAWL')
                                    that.removeDefaultColumn('PMAC')
                                    that.removeDefaultColumn('SAGN')
                                    that.removeDefaultColumn('MAGN')
                                    that.removeColumn('MAWL')
                                    that.removeColumn('PMAC')
                                    that.removeColumn('SAGN')
                                    that.removeColumn('MAGN')
                                }
                                if (that.getUserInfo.AT >= 3) {
                                    that.removeDefaultColumn('AWL')
                                    that.removeDefaultColumn('PAC')
                                    that.removeDefaultColumn('SAGN')
                                    that.removeDefaultColumn('MAGN')
                                    that.removeColumn('AWL')
                                    that.removeColumn('PAC')
                                    that.removeColumn('SAGN')
                                    that.removeColumn('MAGN')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/NetWinLoss/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/TotalWinLossByAG.vue